import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../constants/AuthConstant";
import presensiService from "../../services/presensiService";
import Cookies from "js-cookie";

export const initialState = {
    loading_presensi: false,
    loading_presensi_bulanan: false,
    loading_presensi_all: false,
    loading_rekap_presensi: false,
    data_presensi_bulanan:[],
    data_presensi: [],
    data_presensi_all: [],
    data_rekap_presensi: [],
    data_import: [],
    showMessage:false,
    message:'',
}


export const getDataPresensi = createAsyncThunk('presensi/data',async (data, { rejectWithValue }) => {
    try {
        const response = await presensiService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getDataPresensiBulanan = createAsyncThunk('presensi/show',async (data, { rejectWithValue }) => {
    try {
        const response = await presensiService.show(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getDataRekapPresensi = createAsyncThunk('presensi/rekap',async (data, { rejectWithValue }) => {
    try {
        const response = await presensiService.rekap(Cookies.get(AUTH_TOKEN),data)
        if(response.success!=true){
            message.error(response.message || 'Error',3)
        }else{
            return true
        }
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getDataPresensiAll = createAsyncThunk('presensi/show_all',async (data, { rejectWithValue }) => {
    try {
        const response = await presensiService.show_all(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const downloadPresensi = createAsyncThunk('presensi/download',async (data, { rejectWithValue }) => {
    try {
        const response = await presensiService.download(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})
export const downloadMultiplePresensi = createAsyncThunk('presensi/download',async (data, { rejectWithValue }) => {
    try {
        const response = await presensiService.multiple_download(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const presensiSlice = createSlice({
    name: 'presensi',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_presensi = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataPresensi.fulfilled, (state, action) => {
                state.loading_presensi = false
                state.data_presensi = action.payload??[]
            })
            .addCase(getDataPresensi.pending, (state) => {
                state.loading_presensi = true
            })
            .addCase(getDataPresensi.rejected, (state, action) => {
                state.loading_presensi = false
                state.data_presensi = action.payload
            })
            .addCase(getDataPresensiBulanan.fulfilled, (state, action) => {
                state.loading_presensi_bulanan = false
                state.data_presensi_bulanan = action.payload??[]
            })
            .addCase(getDataPresensiBulanan.pending, (state) => {
                state.loading_presensi_bulanan = true
            })
            .addCase(getDataPresensiBulanan.rejected, (state, action) => {
                state.loading_presensi_bulanan = false
                state.data_presensi_bulanan = action.payload
            })
            .addCase(getDataPresensiAll.fulfilled, (state, action) => {
                state.loading_presensi_all = false
                state.data_presensi_all = action.payload??[]
            })
            .addCase(getDataPresensiAll.pending, (state) => {
                state.loading_presensi_all = true
            })
            .addCase(getDataPresensiAll.rejected, (state, action) => {
                state.loading_presensi_all = false
                state.data_presensi_all = action.payload
            })
            .addCase(getDataRekapPresensi.fulfilled, (state, action) => {
                state.loading_rekap_presensi = false
                state.data_rekap_presensi = action.payload??[]
            })
            .addCase(getDataRekapPresensi.pending, (state) => {
                state.loading_rekap_presensi = true
            })
            .addCase(getDataRekapPresensi.rejected, (state, action) => {
                state.loading_rekap_presensi = false
                state.data_rekap_presensi = action.payload
            })

    },
})

export const {
    showLoading,
} = presensiSlice.actions

export default presensiSlice.reducer
